import { Effect, EffectProperties, EffectFields } from '../../core/Effect';
import * as PostProcessing from '@react-three/postprocessing';
import { forwardRef } from 'react';
import * as THREE from 'three';
import { Field } from '@/types/core/Field';

export interface BloomEffectProperties extends EffectProperties {
  intensity: number;
  luminanceThreshold: number;
  luminanceSmoothing: number;
}

// Create a reusable Bloom component that can be used in both preview and world
const BloomComponent = forwardRef<any, { properties: BloomEffectProperties; isPreview?: boolean }>((props, ref) => {
  const { properties, isPreview } = props;

  if (isPreview) {
    return null;
  }
  
  const { intensity, luminanceThreshold, luminanceSmoothing } = properties;

  return (
    <PostProcessing.Bloom
      ref={ref}
      intensity={intensity}
      luminanceThreshold={luminanceThreshold}
      luminanceSmoothing={luminanceSmoothing}
    />
  );
});

export const BloomEffectItem: Effect<BloomEffectProperties> = {
  id: '',
  name: 'Bloom',
  type: 'effect',
  subtype: 'Bloom',
  icon: 'Effect',
  properties: {
    intensity: 1,
    luminanceThreshold: 0,
    luminanceSmoothing: 0.9,
  },
  fields: [
    ...EffectFields,
    {
      key: 'properties.intensity',
      type: 'number',
      label: 'Intensity',
      default: 1,
      panel: 'effect',
    },
    {
      key: 'properties.luminanceThreshold',
      type: 'number',
      label: 'Luminance Threshold',
      default: 0,
      panel: 'effect',
    },
    {
      key: 'properties.luminanceSmoothing',
      type: 'number',
      label: 'Luminance Smoothing',
      default: 0.9,
      panel: 'effect',
    }
  ],
  render: (properties: BloomEffectProperties, isPreview: boolean, ref: React.RefObject<THREE.Object3D | null>) => {
    return <BloomComponent properties={properties} isPreview={isPreview} ref={ref as any} />;
  }
};
